"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormLayout = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _basis = require("basis");

var _styled = _interopRequireDefault(require("../../theme/styled"));

var _templateObject;

var Container = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  & label {\n    width: 100%;\n    box-sizing: border-box;\n  }\n  & input[type='checkbox'] + label {\n    & > span {\n      width: 100%;\n    }\n  }\n  & a {\n    white-space: nowrap;\n  }\n"])));

var s = {
  Container: Container
};

var FormLayout = function FormLayout(props) {
  var children = props.children,
      className = props.className;
  return /*#__PURE__*/_react.default.createElement(s.Container, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_basis.Grid, {
    rowsGap: "6"
  }, children));
};

exports.FormLayout = FormLayout;